export const environment = {
  production: true,
  baseUrl: 'https://vgaf3eyfw4.execute-api.eu-central-1.amazonaws.com/dev/v1/',
  v3ApiBaseUrl: 'https://api-lms-envx.project-ashton.com/v3/',
  v2ApiBaseUrl: 'https://api-lms-envx.project-ashton.com/v2/',
  v1ApiBaseUrl: 'https://api-lms-envx.project-ashton.com/v1/',
  deviceMgntBaseUrlV2: 'https://api-lms-envx.project-ashton.com/v2/',
  deviceMgntBaseUrlV3: 'https://api-lms-envx.project-ashton.com/v3/',
  redirectUrl: 'https://login.lmsrc.dev.dhr-lsdigital.com/login?client=lms-rc-dev',
  logoutUrl: 'https://lmsrc.dev.dhr-lsdigital.com/assets/logout.html',
  currentClient: 'lms-rc-dev',
  readTenantLambda: 'https://7b3lp7v6a9.execute-api.eu-central-1.amazonaws.com/dev/um-extended-apis/get_tenant_basic_profile',
  getActiveAlarm: 'alarm-management/get-alarm/',
  getAlarmHistory: 'alarm-management/get-alarm-history/',
  getDeviceData: 'device-data-management/get-recent-data/',
  getDeviceDetails: 'device-management/get-device-details/',
  createUser: 'user_management/create_user',
  deleteUser: 'user_management/delete_user/',
  getUserbyID: 'user-data/get-user-by-id/',
  updateAlarm: 'alarm-management/update-alarm',
  getRoles: 'access_management/read_policies',
  getDeviceDataItemList: 'device_management/data_model/get_model?modelId=',
  getDeviceDataChartInfo: 'query_api/get_telemetry_data',
  getDeviceEventDataChartInfo: 'query_api/get_event_list',
  getOrgHierch: 'user_group/get_group_hierarchy',
  deviceDataHistory: 'device-data-management/get-history-data',
  queryApi: 'query_management/query',
  changeUserStatus: 'user_management/update_userstatus/',
  deviceImage: 'device-management/download-image?deviceId=',
  getProvisionedDevices: 'device_management/device_provision/get_devices',
  updateUserName: 'user_management/update_user_by_id/',
  updateUserStatus: 'user_management/update_userstatus/',
  updateProvisionedDevice: 'device_details',
  uploadImage: 'device-management/upload-image',
  moveDevice: 'device_management/device_provision/move_device',
  refreshToken: 'user_authentication/refresh_token',
  getConfig: 'configuration-management/get-config',
  addDeviceStatus: 'device-management/add-device-status',
  getDataModel: 'device_management/data_model/get_model',
  getDeviceStatus: 'device-management/get-device-status/',
  createRuleWithTemplate: 'rule_template/create_template',
  createRule: 'rule_management/create_rule',
  listRule: 'rule_management/list_rule',
  readRule: 'rule_management/read_rule/',
  updatRule: 'rule_management/update_rule',
  createNotification: 'notification_management/create_notification',
  readTenant: 'tenant_management/read_tenant/',
  getDashboardKPIs: 'device-management/get-count-by-device-status',
  getAllDevices: 'device-management/get-all-devices',
  createEmailNotification: 'notification-management/create-notification',
  updateEmailNotification: 'notification-management/update-notification',
  getEmailNotification: 'notification-management/get-notification/',
  moveRelationship: 'user_management/move_relationship',
  getConnectivityStatus: 'device-management/get-connectivity-status/',
  getConnectivityKPIs: 'device-management/get-connectivity-kpi',
  getPermission: 'user-management/get-user-permissions',
  updateDeviceImage: 'device-management/update-image',
  getLaxAndLaserKPI: 'device-management/get-device-lasx-and-laser-kpi',
  getDeviceUtilizationKPI: 'device-management/get-device-utilization-kpi/',
  transferDeviceFile: 'device-file-management/generate-file-command',
  transferDeviceFileStatus:
    'device-file-management/get-all-file-transfer-status/',
  getDeviceFile: 'device_management/file_transfer/get_file',
  devicePropertiesURI: 'device_properties',
  exportCsv: 'report-management/export-csv',
  authenticateLogout: 'user_authentication/logout',
  getUserType: 'user-management/get-user-userType',
  getPhysicalModel: 'device-management/get-physical-data-model',
  addPhysicalDevice: 'device-management/add-physical-data-model',
  deleteRule: 'rule_management/delete_rule/',
  getNotificationsByRuleId:
    'notification_management/list_notifications_by_ruleId',
  deleteNotification: 'notification_management/delete_notification  ',
  getWatchlist: 'device-management/get-watchlist',
  toggleWatchlist: 'device-management/toggle-watchlist',
  getNotes: 'note-management/get-notes/',
  deleteNote: 'note-management/delete-note/',
  createNote: 'note-management/add-note',
  addToLastViewed: 'device-management/add-to-lastviewed',
  exportAlarmCSV: 'report-management/alarm-csv',
  exportDataItemCSV: 'report-management/data-item-csv',
  logReadAlarm: 'alarm-management/push-alarm-log',
  blockDevice: 'device_management/device_provision/block_device?deviceId=',
  removeWatchlistDevice: 'device-management/remove-watchlist/',
  changeRuleStatus: 'rule_management/update_rule_status',
  getDomain: 'user_group/get_domain',
  uploadNoteFile: 'device-management/upload-note-file',
  downloadNoteFile: 'note-management/download-note-file?deviceId=',
  deleteNoteFile: 'note-management/delete-note-file?deviceId=',
  getDataItemList: 'device_management/data_model/get_model',
  getModelIdByPhysicalModelId: 'report-management/get-modelId-by-physicalModelId?physicalDataModel=',
  getCompanyDetails: 'carc-company-management/get-company-details?companyId=',
  getRogueDeviceData: 'device-data-management/get-rogue-device-data',
  unblockDevice: 'device-data-management/unblock-device',
  getRulesList: 'rule-management/get-rule-list',
  getUserById: 'note-management/get-user-by-id',
  ruleMngmntGetUserById: 'user_management/get_user_by_id/',
  getDataModelSwVersion: 'device-data-management/get-data-model-sw-version',
  getProveoKpi: 'device-management/get-proveo-kpi',
  Model_List: 'LMS_ARveo_8,LMS_ARveo_8x,LMS_Proveo_8x,LMS Proveo_8x, Proveo-8x, Proveo_8x, Proveo 8x,UC_Enuity_flat',
  resetMaintenanceCounter: 'device-management/reset-maintenance-counter',
  getUcEnuityKpi: 'device-management/get-ucenuity-kpi',
  deleteUserDetails: 'user-data/delete-user-details',
  deleteNotificationByRuleId: 'notification-management/delete-notification/',
  updateRuleStatusForNotification: 'notification-management/update-rule-status-for-notification',
  getSfdcCases: 'devices/{deviceId}/cases',
  deviceListPollingInterval : 14400000,
  connectivityKPIPollingInterval : 14400000,
  watchlistPollingInterval : 14400000,
  getAroveoKpi: 'device-kpi/get-arveo-kpi',
  regionURI: 'regions',
  subRegionURI: 'sub-regions',
  featureToggleURI: 'feature-toggles',
  auth0Domain: 'https://dev.login.lifesciences.danaher.com',
  auth0ClientId: 'fFR5Q3F3kGaOWIzNI2ueNichhKvtnjIr',
};
